import React from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import {
  FeedingGuidelinesRoot,
  GuidelineList,
  Guideline,
  DogImagesWrapper,
  DogImage,
  WeightRangeIndicator,
  WeightText,
  Span,
  RedArrow,
  WeightWrapper,
} from './FeedingGuidelines.styles'
import smallDog from '../../../../../../../../public/assets/product/smallDog.png'
import mediumDog from '../../../../../../../../public/assets/product/mediumDog.png'
import largeDog from '../../../../../../../../public/assets/product/largeDog.png'
import xlargeDog from '../../../../../../../../public/assets/product/xlargeDog.png'
import xxlargeDog from '../../../../../../../../public/assets/product/xxlargeDog.png'
import { SectionTitle } from 'features/ECommerce/screens/AllProducts/AllProducts.styles'
import Trans from 'next-translate/Trans'
import { Icon } from 'components/Icon'

export const FeedingGuidelines: React.FC = () => {
  const { t } = useTranslation('products')

  return (
    <FeedingGuidelinesRoot>
      <SectionTitle>{t('products:feedingGuidelines.title')}</SectionTitle>
      <GuidelineList className="desktop">
        <Guideline>
          <Trans i18nKey={'products:feedingGuidelines.upTo5lbs'} components={{ Span: <Span /> }} />
        </Guideline>
        <Guideline>
          <Trans i18nKey={'products:feedingGuidelines.6to10lbs'} components={{ Span: <Span /> }} />
        </Guideline>
        <Guideline>
          <Trans i18nKey={'products:feedingGuidelines.11to14lbs'} components={{ Span: <Span /> }} />
        </Guideline>
        <Guideline>
          <Trans i18nKey={'products:feedingGuidelines.15to19lbs'} components={{ Span: <Span /> }} />
        </Guideline>
        <Guideline>
          <Trans i18nKey={'products:feedingGuidelines.20to150lbs'} components={{ Span: <Span /> }} />
        </Guideline>
      </GuidelineList>
      <GuidelineList className="mobile">
        <Guideline>
          <Trans
            i18nKey={'products:feedingGuidelines.upTo5lbsMobile'}
            components={{ Span: <Span />, br: <br /> }}
          />
        </Guideline>
        <Guideline>
          <Trans
            i18nKey={'products:feedingGuidelines.6to10lbsMobile'}
            components={{ Span: <Span />, br: <br /> }}
          />
        </Guideline>
        <Guideline>
          <Trans
            i18nKey={'products:feedingGuidelines.11to14lbsMobile'}
            components={{ Span: <Span />, br: <br /> }}
          />
        </Guideline>
        <Guideline>
          <Trans
            i18nKey={'products:feedingGuidelines.15to19lbsMobile'}
            components={{ Span: <Span />, br: <br /> }}
          />
        </Guideline>
        <Guideline>
          <Trans
            i18nKey={'products:feedingGuidelines.20to150lbsMobile'}
            components={{ Span: <Span />, br: <br /> }}
          />
        </Guideline>
      </GuidelineList>
      <DogImagesWrapper>
        <DogImage dog={'smallDog'}>
          <Image src={smallDog} alt={t('products:feedingGuidelines.smallDogAlt')} />
        </DogImage>
        <DogImage dog={'mediumDog'}>
          <Image src={mediumDog} alt={t('products:feedingGuidelines.mediumDogAlt')} />
        </DogImage>
        <DogImage dog={'largeDog'}>
          <Image src={largeDog} alt={t('products:feedingGuidelines.largeDogAlt')} />
        </DogImage>
        <DogImage dog={'xlargeDog'}>
          <Image src={xlargeDog} alt={t('products:feedingGuidelines.xlargeDogAlt')} />
        </DogImage>
        <DogImage dog={'xxlargeDog'}>
          <Image src={xxlargeDog} alt={t('products:feedingGuidelines.giantDogAlt')} />
        </DogImage>
      </DogImagesWrapper>
      <RedArrow>
        <Icon css={{ marginRight: '-36px' }} name="angle-left" color="primary-500" size="8" />
        <WeightRangeIndicator />
        <Icon css={{ marginLeft: '-36px' }} name="angle-right" color="primary-500" size="8" />
      </RedArrow>
      <WeightWrapper>
        <WeightText>
          <Trans
            i18nKey={'products:feedingGuidelines.lowWeightPercentage'}
            components={{ br: <br /> }}
          />
        </WeightText>
        <WeightText>
          <Trans
            i18nKey={'products:feedingGuidelines.highWeightPercentage'}
            components={{ br: <br /> }}
          />
        </WeightText>
      </WeightWrapper>
    </FeedingGuidelinesRoot>
  )
}
